import { ReactNode, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
 

// 📌 Definiendo la interfaz de los props del AccordionItem
interface AccordionItemProps {
  title: string;          // Título del acordeón
  index: number;          // Índice del elemento
  isOpen: boolean;        // Indica si está abierto o cerrado
  onClick: (index: number) => void;  // Función para manejar el clic
  className?:string;
  classNameHead?:string;
  icon?: React.ReactNode;
  children: ReactNode;    // Contenido dentro del acordeón 
}

const AccordionItem: React.FC<AccordionItemProps> = ({ title, index, isOpen, onClick, className, classNameHead, icon, children }) => {
  return (
    <div className={`border border-gray-200 rounded-2xl overflow-hidden n-elevation-1 ${className}`}>
      {/* Botón del acordeón */}
      <button
        type="button"
        className={`w-full flex justify-between items-center bg-gray-100 px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-200 transition-all ${classNameHead}`}
        onClick={() => onClick(index)}
      >
        {icon}
        <span className="flex-1 text-left ml-2 font-semibold">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 items-end" /> : <ChevronDown className="w-5 h-5 items-end" />}
      </button>

        <div className={` transition-all ${isOpen?'bg-white border-t border-gray-300 animate-fade-in':'h-0 max-h-0 opacity-0'}`}>
          {children}
        </div>
      {/* Contenido del acordeón 
      {isOpen && (
        <div className={`bg-white border-t border-gray-300 animate-fade-in ${}`}>
          {children}
        </div>
      )}
        */}
    </div>
  );
};
 
export default AccordionItem;
